export default "__VITE_ASSET__DhMZiGeF__"